import TableHead from "./TableHead.js";
import SecTableBody from "./SecTableBody.js";
import { useSortableTable } from "../hooks/useSortableTable.js";

export default function SecondTable({ caption, data, columns }) {
  const [tableData, handleSorting, delRow] = useSortableTable(data);

  return (
    <table className="ui unstackable celled table">
      <caption className="ui header">
        {caption}
      </caption>
      <TableHead columns={columns} handleSorting={handleSorting} />
      <SecTableBody columns={columns} tableData={tableData} delRow={delRow} />
    </table>
  );
}
